import "./TD1AdminFormUI.css";

import { Box, Grid, useTheme } from "@mui/material";
import { FC, useEffect, useState } from "react";

import { Calendar } from "primereact/calendar";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { RHookFormNumberField } from "@websential/cosmic-v20";

// import { Button } from "primereact/button";

// import { Toolbar } from "primereact/toolbar";





// import {
// 	TD1AdminFormheaderColumnsWithFixedRows,
// 	td1AdminFormInitialDataWithFixedRows,
// } from "../../TD1AdminForm";



// let emptyTd1Form = {
// 	id: null,
// 	heading: "",
// 	details: "",
// 	value: null,
// 	xCordinate: null,
// 	yCordinate: null,
// };

interface ITD1AdminFormDataWithFixedRowsTable {
	// td1AdminFormDataWithFixedRows: (data: any) => void;
}
export const TD1AdminFormDataTableWithFixedRows: FC<
	ITD1AdminFormDataWithFixedRowsTable
> = ({
	// td1AdminFormDataWithFixedRows 
}) => {
		// const theme = useTheme();
		// const [td1AdminForm, setTD1AdminForm] = useState<any>(
		// 	td1AdminFormInitialDataWithFixedRows
		// );
		// const [selectedTD1AdminForm, setSelectedTD1AdminForm] = useState<any>(null);

		// useEffect(() => {
		// 	td1AdminFormDataWithFixedRows(td1AdminForm);
		// }, [td1AdminForm]);

		// const findIndexById = (id: string | number | any) => {
		// 	let index = -1;

		// 	for (let i = 0; i < td1AdminForm.length; i++) {
		// 		if (td1AdminForm[i].id === id) {
		// 			index = i;
		// 			break;
		// 		}
		// 	}

		// 	return index;
		// };

		// const createId = () => {
		// 	let id = "";
		// 	let chars =
		// 		"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

		// 	for (let i = 0; i < 5; i++) {
		// 		id += chars.charAt(Math.floor(Math.random() * chars.length));
		// 	}

		// 	return id;
		// };

		// const onCellValueChange = (event: any, rowIndex: number, field: any) => {
		// 	const updatedData = [...td1AdminForm];
		// 	updatedData[rowIndex][event.field] = field;
		// 	setTD1AdminForm(updatedData);
		// };

		// const renderErrorClass = (field: any, rowIndex: number, rowData: any) => {
		// 	return "p-component p-filled input-dropdown-fields";
		// };

		// const columnsBody = (rowData: any, row: any, x: any) => {
		// 	if (x.field === "heading") {
		// 		return <span>{rowData[x.field]}</span>;
		// 	} else if (x.field === "xCordinate") {
		// 		return (
		// 			<InputNumber
		// 				value={rowData[x.field]}
		// 				onChange={(e: any) => onCellValueChange(x, row.rowIndex, e.value)}
		// 				className={renderErrorClass(x, row.rowIndex, rowData)}
		// 			/>
		// 		);
		// 	} else if (x.field === "yCordinate") {
		// 		return (
		// 			<InputNumber
		// 				value={rowData[x.field]}
		// 				onChange={(e: any) => onCellValueChange(x, row.rowIndex, e.value)}
		// 				className={renderErrorClass(x, row.rowIndex, rowData)}
		// 			/>
		// 		);
		// 	}
		// };



		return (
			<>
				<div className="card" style={{ marginTop: "2rem" }}>
					{/* <DataTable 
                    value={td1AdminForm} 
                    // selection={selectedTD1AdminForm} 
                    // onSelectionChange={(e) => setSelectedTD1AdminForm(e.value)}
                    dataKey="id"  
                    showGridlines
                    className="TD1AdminForm"
                    editMode="cell"
                    resizableColumns
                    columnResizeMode="expand"
                    scrollable
                    // reorderableColumns
                    filterDisplay="menu"
                >
                    {TD1AdminFormheaderColumnsWithFixedRows &&
                            <Column 
                              header="" 
                              className="indexColumn" 
                              headerStyle={{ width: '3rem' }} 
                              frozen
                              // hidden={!showIndexColumn}
                              body={(data, options) => "(" + String.fromCharCode(97 + options.rowIndex) + ")"}>
                          </Column>}
                    {TD1AdminFormheaderColumnsWithFixedRows.map((x: any, index: any) => {
                        return (
                          <Column
                            key={index}
                            field={x.field}
                            header={x.headerName}
                            headerTooltip={x.description}
                            headerTooltipOptions={{ position: "top" }}
                            // sortable={false}
                            // resizeable={x.resizable}
                            // dataType={x.type}
                            align={x.align}
                            alignHeader={x.headerAlign}
                            // reorderable={x.disableReorder}
                            // exportable={x.disableExport}
                            frozen={x.frozenColumn}
                            columnKey={x.field}
                            style={{
                              width: x.minWidth,
                              fontSize: "0.875rem",
                            }}
                            footer={x.footer}
                            body={(rowData:any,row:any) => columnsBody(rowData,row,x)}
                          />
                        );
                      })}
                </DataTable> */}

					<Grid
						sx={{
							fontFamily: "var(--font-family)",
						}}
					>
						{/* Header */}
						<Grid sx={{ display: "flex", height: "2.2rem" }}>
							<Box
								sx={{
									borderBottom: "1px solid #e5e7eb",
									borderLeft: "1px solid #e5e7eb",
									borderTop: "1px solid #e5e7eb",
									width: "3%",
									background: "#f9fafb",
								}}
							></Box>
							<Box
								sx={{
									padding: "2px",
									fontSize: ".875rem",
									fontWeight: "bold",
									borderWidth: "0 0 1px 1px",
									borderBottom: "1px solid #e5e7eb",
									borderLeft: "1px solid #e5e7eb",
									borderTop: "1px solid #e5e7eb",
									width: "73%",
									display: "flex",
									alignItems: "center",
									justifyContent: "center",
									background: "#f9fafb",
								}}
							>
								<Box>Heading</Box>
							</Box>
							<Box
								sx={{
									padding: "2px",
									textAlign: "center",
									fontSize: ".875rem",
									fontWeight: "bold",
									borderWidth: "0 0 1px 1px",
									borderBottom: "1px solid #e5e7eb",
									borderLeft: "1px solid #e5e7eb",
									borderTop: "1px solid #e5e7eb",
									width: "12%",
									display: "flex",
									alignItems: "center",
									justifyContent: "center",
									background: "#f9fafb",
								}}
							>
								X-Cordinate
							</Box>
							<Box
								sx={{
									padding: "2px",
									textAlign: "center",
									fontSize: ".875rem",
									fontWeight: "bold",
									borderWidth: "0 0 1px 1px",
									border: "1px solid #e5e7eb",
									width: "12%",
									display: "flex",
									alignItems: "center",
									justifyContent: "center",
									background: "#f9fafb",
								}}
							>
								Y-Cordinate
							</Box>
						</Grid>

						{/* Row 1 */}
						<Grid sx={{ display: "flex", height: "2.8rem" }}>
							<Box
								sx={{
									padding: "10px",
									textAlign: "center",
									fontSize: ".875rem",
									borderWidth: "0 0 1px 1px",
									borderBottom: "1px solid #e5e7eb",
									borderLeft: "1px solid #e5e7eb",
									color: "#4b5563",
									width: "3%",
								}}
							>
								(a)
							</Box>
							<Box
								sx={{
									padding: "2px",
									fontSize: ".875rem",
									borderWidth: "0 0 1px 1px",
									borderBottom: "1px solid #e5e7eb",
									borderLeft: "1px solid #e5e7eb",
									color: "#4b5563",
									width: "73%",
									display: "flex",
									alignItems: "center",
								}}
							>
								<Box>Enter the x/y Cordinates of Last Name</Box>
							</Box>
							<Box
								sx={{
									padding: "2px",
									textAlign: "center",
									fontSize: ".875rem",
									borderWidth: "0 0 1px 1px",
									borderBottom: "1px solid #e5e7eb",
									borderLeft: "1px solid #e5e7eb",
									color: "#4b5563",
									width: "12%",
								}}
							>
								<RHookFormNumberField id={"lastNameX"} testId="lastNameX" />
							</Box>
							<Box
								sx={{
									padding: "2px",
									textAlign: "center",
									fontSize: ".875rem",
									borderWidth: "0 0 1px 1px",
									borderBottom: "1px solid #e5e7eb",
									borderLeft: "1px solid #e5e7eb",
									borderRight: "1px solid #e5e7eb",
									color: "#4b5563",
									width: "12%",
								}}
							>
								<RHookFormNumberField id={"lastNameY"} testId="lastNameY" />
							</Box>
						</Grid>
						{/* Row 2 */}
						<Grid sx={{ display: "flex", height: "2.8rem" }}>
							<Box
								sx={{
									padding: "10px",
									textAlign: "center",
									fontSize: ".875rem",
									borderWidth: "0 0 1px 1px",
									borderBottom: "1px solid #e5e7eb",
									borderLeft: "1px solid #e5e7eb",
									color: "#4b5563",
									width: "3%",
								}}
							>
								(b)
							</Box>
							<Box
								sx={{
									padding: "2px",
									fontSize: ".875rem",
									borderWidth: "0 0 1px 1px",
									borderBottom: "1px solid #e5e7eb",
									borderLeft: "1px solid #e5e7eb",
									color: "#4b5563",
									width: "73%",
									display: "flex",
									alignItems: "center",
								}}
							>
								<Box>Enter the x/y Cordinates of First Name</Box>
							</Box>
							<Box
								sx={{
									padding: "2px",
									textAlign: "center",
									fontSize: ".875rem",
									borderWidth: "0 0 1px 1px",
									borderBottom: "1px solid #e5e7eb",
									borderLeft: "1px solid #e5e7eb",
									color: "#4b5563",
									width: "12%",
								}}
							>
								<RHookFormNumberField id={"firstNameX"} testId="firstNameX" />
							</Box>
							<Box
								sx={{
									padding: "2px",
									textAlign: "center",
									fontSize: ".875rem",
									borderWidth: "0 0 1px 1px",
									borderBottom: "1px solid #e5e7eb",
									borderLeft: "1px solid #e5e7eb",
									borderRight: "1px solid #e5e7eb",
									color: "#4b5563",
									width: "12%",
								}}
							>
								<RHookFormNumberField id={"firstNameY"} testId="firstNameY" />
							</Box>
						</Grid>
						{/* Row 3 */}
						<Grid sx={{ display: "flex", height: "2.8rem" }}>
							<Box
								sx={{
									padding: "10px",
									textAlign: "center",
									fontSize: ".875rem",
									borderWidth: "0 0 1px 1px",
									borderBottom: "1px solid #e5e7eb",
									borderLeft: "1px solid #e5e7eb",
									color: "#4b5563",
									width: "3%",
								}}
							>
								(c)
							</Box>
							<Box
								sx={{
									padding: "2px",
									fontSize: ".875rem",
									borderWidth: "0 0 1px 1px",
									borderBottom: "1px solid #e5e7eb",
									borderLeft: "1px solid #e5e7eb",
									color: "#4b5563",
									width: "73%",
									display: "flex",
									alignItems: "center",
								}}
							>
								<Box>Enter the x/y Cordinates of Date of Birth</Box>
							</Box>
							<Box
								sx={{
									padding: "2px",
									textAlign: "center",
									fontSize: ".875rem",
									borderWidth: "0 0 1px 1px",
									borderBottom: "1px solid #e5e7eb",
									borderLeft: "1px solid #e5e7eb",
									color: "#4b5563",
									width: "12%",
								}}
							>
								<RHookFormNumberField id={"dateOfBirthX"} testId="dateOfBirthX" />
							</Box>
							<Box
								sx={{
									padding: "2px",
									textAlign: "center",
									fontSize: ".875rem",
									borderWidth: "0 0 1px 1px",
									borderBottom: "1px solid #e5e7eb",
									borderLeft: "1px solid #e5e7eb",
									borderRight: "1px solid #e5e7eb",
									color: "#4b5563",
									width: "12%",
								}}
							>
								<RHookFormNumberField id={"dateOfBirthY"} testId="dateOfBirthY" />
							</Box>
						</Grid>
						{/* Row 4 */}
						<Grid sx={{ display: "flex", height: "2.8rem" }}>
							<Box
								sx={{
									padding: "10px",
									textAlign: "center",
									fontSize: ".875rem",
									borderWidth: "0 0 1px 1px",
									borderBottom: "1px solid #e5e7eb",
									borderLeft: "1px solid #e5e7eb",
									color: "#4b5563",
									width: "3%",
								}}
							>
								(d)
							</Box>
							<Box
								sx={{
									padding: "2px",
									fontSize: ".875rem",
									borderWidth: "0 0 1px 1px",
									borderBottom: "1px solid #e5e7eb",
									borderLeft: "1px solid #e5e7eb",
									color: "#4b5563",
									width: "73%",
									display: "flex",
									alignItems: "center",
								}}
							>
								<Box>Enter the x/y Cordinates of Employee No</Box>
							</Box>
							<Box
								sx={{
									padding: "2px",
									textAlign: "center",
									fontSize: ".875rem",
									borderWidth: "0 0 1px 1px",
									borderBottom: "1px solid #e5e7eb",
									borderLeft: "1px solid #e5e7eb",
									color: "#4b5563",
									width: "12%",
								}}
							>
								<RHookFormNumberField id={"employeeNumberX"} testId="employeeNumberX" />
							</Box>
							<Box
								sx={{
									padding: "2px",
									textAlign: "center",
									fontSize: ".875rem",
									borderWidth: "0 0 1px 1px",
									borderBottom: "1px solid #e5e7eb",
									borderLeft: "1px solid #e5e7eb",
									borderRight: "1px solid #e5e7eb",
									color: "#4b5563",
									width: "12%",
								}}
							>
								<RHookFormNumberField id={"employeeNumberY"} testId="employeeNumberY" />
							</Box>
						</Grid>
						{/* Row 5 */}
						<Grid sx={{ display: "flex", height: "2.8rem" }}>
							<Box
								sx={{
									padding: "10px",
									textAlign: "center",
									fontSize: ".875rem",
									borderWidth: "0 0 1px 1px",
									borderBottom: "1px solid #e5e7eb",
									borderLeft: "1px solid #e5e7eb",
									color: "#4b5563",
									width: "3%",
								}}
							>
								(e)
							</Box>
							<Box
								sx={{
									padding: "2px",
									fontSize: ".875rem",
									borderWidth: "0 0 1px 1px",
									borderBottom: "1px solid #e5e7eb",
									borderLeft: "1px solid #e5e7eb",
									color: "#4b5563",
									width: "73%",
									display: "flex",
									alignItems: "center",
								}}
							>
								<Box>Enter the x/y Cordinates of Address</Box>
							</Box>
							<Box
								sx={{
									padding: "2px",
									textAlign: "center",
									fontSize: ".875rem",
									borderWidth: "0 0 1px 1px",
									borderBottom: "1px solid #e5e7eb",
									borderLeft: "1px solid #e5e7eb",
									color: "#4b5563",
									width: "12%",
								}}
							>
								<RHookFormNumberField id={"addressWithPostCodeX"} testId="addressWithPostCodeX" />
							</Box>
							<Box
								sx={{
									padding: "2px",
									textAlign: "center",
									fontSize: ".875rem",
									borderWidth: "0 0 1px 1px",
									borderBottom: "1px solid #e5e7eb",
									borderLeft: "1px solid #e5e7eb",
									borderRight: "1px solid #e5e7eb",
									color: "#4b5563",
									width: "12%",
								}}
							>
								<RHookFormNumberField id={"addressWithPostCodeY"} testId="addressWithPostCodeY" />
							</Box>
						</Grid>
						{/* Row 6 */}
						<Grid sx={{ display: "flex", height: "2.8rem" }}>
							<Box
								sx={{
									padding: "10px",
									textAlign: "center",
									fontSize: ".875rem",
									borderWidth: "0 0 1px 1px",
									borderBottom: "1px solid #e5e7eb",
									borderLeft: "1px solid #e5e7eb",
									color: "#4b5563",
									width: "3%",
								}}
							>
								(f)
							</Box>
							<Box
								sx={{
									padding: "2px",
									fontSize: ".875rem",
									borderWidth: "0 0 1px 1px",
									borderBottom: "1px solid #e5e7eb",
									borderLeft: "1px solid #e5e7eb",
									color: "#4b5563",
									width: "73%",
									display: "flex",
									alignItems: "center",
								}}
							>
								<Box>Enter the x/y Cordinates of postcode</Box>
							</Box>
							<Box
								sx={{
									padding: "2px",
									textAlign: "center",
									fontSize: ".875rem",
									borderWidth: "0 0 1px 1px",
									borderBottom: "1px solid #e5e7eb",
									borderLeft: "1px solid #e5e7eb",
									color: "#4b5563",
									width: "12%",
								}}
							>
								<RHookFormNumberField id={"postCodeX"} testId="postCodeX" />
							</Box>
							<Box
								sx={{
									padding: "2px",
									textAlign: "center",
									fontSize: ".875rem",
									borderWidth: "0 0 1px 1px",
									borderBottom: "1px solid #e5e7eb",
									borderLeft: "1px solid #e5e7eb",
									borderRight: "1px solid #e5e7eb",
									color: "#4b5563",
									width: "12%",
								}}
							>
								<RHookFormNumberField id={"postCodeY"} testId="postCodeY" />
							</Box>
						</Grid>
						{/* Row 7 */}
						<Grid sx={{ display: "flex", height: "2.8rem" }}>
							<Box
								sx={{
									padding: "10px",
									textAlign: "center",
									fontSize: ".875rem",
									borderWidth: "0 0 1px 1px",
									borderBottom: "1px solid #e5e7eb",
									borderLeft: "1px solid #e5e7eb",
									color: "#4b5563",
									width: "3%",
								}}
							>
								(g)
							</Box>
							<Box
								sx={{
									padding: "2px",
									fontSize: ".875rem",
									borderWidth: "0 0 1px 1px",
									borderBottom: "1px solid #e5e7eb",
									borderLeft: "1px solid #e5e7eb",
									color: "#4b5563",
									width: "73%",
									display: "flex",
									alignItems: "center",
								}}
							>
								<Box>Enter the x/y Cordinates of Social Insurance no</Box>
							</Box>
							<Box
								sx={{
									padding: "2px",
									textAlign: "center",
									fontSize: ".875rem",
									borderWidth: "0 0 1px 1px",
									borderBottom: "1px solid #e5e7eb",
									borderLeft: "1px solid #e5e7eb",
									color: "#4b5563",
									width: "12%",
								}}
							>
								<RHookFormNumberField id={"socialInsuranceNumberX"} testId="socialInsuranceNumberX" />
							</Box>
							<Box
								sx={{
									padding: "2px",
									textAlign: "center",
									fontSize: ".875rem",
									borderWidth: "0 0 1px 1px",
									borderBottom: "1px solid #e5e7eb",
									borderLeft: "1px solid #e5e7eb",
									borderRight: "1px solid #e5e7eb",
									color: "#4b5563",
									width: "12%",
								}}
							>
								<RHookFormNumberField id={"socialInsuranceNumberY"} testId="socialInsuranceNumberY" />
							</Box>
						</Grid>
						{/* Row 8 */}
						<Grid sx={{ display: "flex", height: "2.8rem" }}>
							<Box
								sx={{
									padding: "10px",
									textAlign: "center",
									fontSize: ".875rem",
									borderWidth: "0 0 1px 1px",
									borderBottom: "1px solid #e5e7eb",
									borderLeft: "1px solid #e5e7eb",
									color: "#4b5563",
									width: "3%",
								}}
							>
								(h)
							</Box>
							<Box
								sx={{
									padding: "2px",
									fontSize: ".875rem",
									borderWidth: "0 0 1px 1px",
									borderBottom: "1px solid #e5e7eb",
									borderLeft: "1px solid #e5e7eb",
									color: "#4b5563",
									width: "73%",
									display: "flex",
									alignItems: "center",
								}}
							>
								<Box>Enter the x/y Cordinates of Deduction for living in a prescribed zone</Box>
							</Box>
							<Box
								sx={{
									padding: "2px",
									textAlign: "center",
									fontSize: ".875rem",
									borderWidth: "0 0 1px 1px",
									borderBottom: "1px solid #e5e7eb",
									borderLeft: "1px solid #e5e7eb",
									color: "#4b5563",
									width: "12%",
								}}
							>
								<RHookFormNumberField id={"deductionForLivingInAPrescribedZoneX"} testId="deductionForLivingInAPrescribedZoneX" />
							</Box>
							<Box
								sx={{
									padding: "2px",
									textAlign: "center",
									fontSize: ".875rem",
									borderWidth: "0 0 1px 1px",
									borderBottom: "1px solid #e5e7eb",
									borderLeft: "1px solid #e5e7eb",
									borderRight: "1px solid #e5e7eb",
									color: "#4b5563",
									width: "12%",
								}}
							>
								<RHookFormNumberField id={"deductionForLivingInAPrescribedZoneY"} testId="deductionForLivingInAPrescribedZoneY" />
							</Box>
						</Grid>
						{/* Row 9 */}
						<Grid sx={{ display: "flex", height: "2.7rem" }}>
							<Box
								sx={{
									padding: "10px",
									textAlign: "center",
									fontSize: ".875rem",
									borderWidth: "0 0 1px 1px",
									borderBottom: "1px solid #e5e7eb",
									borderLeft: "1px solid #e5e7eb",
									color: "#4b5563",
									width: "3%",
								}}
							>
								(i)
							</Box>
							<Box
								sx={{
									padding: "2px",
									fontSize: ".875rem",
									borderWidth: "0 0 1px 1px",
									borderBottom: "1px solid #e5e7eb",
									borderLeft: "1px solid #e5e7eb",
									color: "#4b5563",
									width: "73%",
									display: "flex",
									alignItems: "center",
								}}
							>
								<Box>Enter the x/y Cordinates of Additional tax to be deducted</Box>
							</Box>
							<Box
								sx={{
									padding: "2px",
									textAlign: "center",
									fontSize: ".875rem",
									borderWidth: "0 0 1px 1px",
									borderBottom: "1px solid #e5e7eb",
									borderLeft: "1px solid #e5e7eb",
									color: "#4b5563",
									width: "12%",
								}}
							>
								<RHookFormNumberField id={"additionalTaxToBeDeductedX"} testId="additionalTaxToBeDeductedX" />
							</Box>
							<Box
								sx={{
									padding: "2px",
									textAlign: "center",
									fontSize: ".875rem",
									borderWidth: "0 0 1px 1px",
									borderBottom: "1px solid #e5e7eb",
									borderLeft: "1px solid #e5e7eb",
									borderRight: "1px solid #e5e7eb",
									color: "#4b5563",
									width: "12%",
								}}
							>
								<RHookFormNumberField id={"additionalTaxToBeDeductedY"} testId="additionalTaxToBeDeductedY" />
							</Box>
						</Grid>
					</Grid>
				</div>
			</>
		);
	};
